// pages/Dashboard.jsx
import Signup from "../../components/home/authComponents/Signup";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <Signup />
    </HomeLayout>
  );
}
